import { render, staticRenderFns } from "./OtherData.vue?vue&type=template&id=601f95a4&scoped=true&"
import script from "./OtherData.vue?vue&type=script&lang=js&"
export * from "./OtherData.vue?vue&type=script&lang=js&"
import style0 from "./OtherData.vue?vue&type=style&index=0&id=601f95a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601f95a4",
  null
  
)

export default component.exports